import { cmsRepository } from '~/repository/cmsRepository'
import type { WidgetItem, ListItem } from '~/types/ProDuctList.d.ts'

export const usePageDescription = async (
  pageKey: 'Devices' | 'Collabs' | 'Products' | 'Styles'
) => {
  const route = useRoute()
  const { $serverApi } = useNuxtApp()
  const cmsRepo = cmsRepository($serverApi)

  const pageKeyType = pageKey
    ? pageKey.charAt(0).toUpperCase() + pageKey.slice(1)
    : ''

  const { data: pageData } = await useAsyncData(
    `page-navigation-${pageKeyType}`,
    async () => await cmsRepo.getWidget('navigation')
  )

  const items = pageData.value?.data?.data?.items?.[0] || []

  const widgetItem = items.find(
    (e: WidgetItem) =>
      e?.titleEn?.trim().toLowerCase() === pageKeyType.trim().toLowerCase() ||
      e?.href?.replace(/\/+$/, '') === `/${pageKey.toLowerCase()}`
  )

  console.log('widgetItem', widgetItem)

  const normalizePath = (path: string) =>
    path
      .split('?')[0]
      .replace(/^\/(th|en)/, '')
      .replace(/\/+$/, '') || '/'

  const contentMap: Record<
    string,
    { contentDescriptionEn: string | null; contentDescriptionTh: string | null }
  > = {}

  if (widgetItem?.href) {
    const cleanHref = normalizePath(widgetItem.href)
    contentMap[cleanHref] = {
      contentDescriptionEn: widgetItem.contentDescriptionEn ?? null,
      contentDescriptionTh: widgetItem.contentDescriptionTh ?? null
    }
  }

  widgetItem?.listMenu?.forEach((section: ListItem) => {
    const sources = [...(section.menus ?? []), ...(section.cards ?? [])]

    sources.forEach((item) => {
      const groupDescEn = item.contentDescriptionEn ?? null
      const groupDescTh = item.contentDescriptionTh ?? null

      if (item.footerMenuHref) {
        const cleanFooter = normalizePath(item.footerMenuHref)
        if (!contentMap[cleanFooter]) {
          contentMap[cleanFooter] = {
            contentDescriptionEn: groupDescEn,
            contentDescriptionTh: groupDescTh
          }
        }
      }

      item.items?.forEach((childRaw) => {
        const child = childRaw as {
          href: string
          contentDescriptionEn?: string
          contentDescriptionTh?: string
        }

        const cleanChildHref = child.href
          ? normalizePath(child.href)
          : undefined

        if (cleanChildHref && !contentMap[cleanChildHref]) {
          contentMap[cleanChildHref] = {
            contentDescriptionEn: child.contentDescriptionEn ?? null,
            contentDescriptionTh: child.contentDescriptionTh ?? null
          }
        }
      })
    })
  })

  const cleanPath = normalizePath(route.path)
  const matched = Object.entries(contentMap).find(([key]) => key === cleanPath)

  return {
    dataPage: matched
      ? {
          contentDescriptionEn: matched[1].contentDescriptionEn,
          contentDescriptionTh: matched[1].contentDescriptionTh,
          url: [matched[0]]
        }
      : {
          contentDescriptionEn: null,
          contentDescriptionTh: null,
          url: []
        },
    listMenu: contentMap,
    pageData
  }
}
